import { Fancybox } from "@fancyapps/ui";

Fancybox.bind('[data-fancybox]:not(.slick-cloned [data-fancybox])', {});
